import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

function LoadingBox({ overlay = false }) {
  const { t } = useTranslation();

  const baseStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const overlayStyles = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 9999,
  };

  const spinnerStyles = {
    width: overlay ? '3rem' : '2rem',
    height: overlay ? '3rem' : '2rem',
    color: overlay ? 'white' : 'var(--secondaryColor)',
  };

  return (
    <div style={overlay ? { ...baseStyles, ...overlayStyles } : baseStyles}>
      <Spinner animation='border' role='status' style={spinnerStyles}>
        <span className='visually-hidden'>{t('common.loading')}</span>
      </Spinner>
    </div>
  );
}

export default LoadingBox;
